<div class="cm-contenido-central">
  <div class="toolsField">
    <div>
      <div [formGroup]="filterForm" class="filters">
        <mat-form-field appearance="outline" class="filters__biggest">
          <mat-label>Buscar por palabra clave</mat-label>
          <input formControlName="text" matInput value="" autocomplete="off">
        </mat-form-field>
        <div class="gap"></div>
        <mat-form-field appearance="outline" class="filters__normal">
          <mat-label>Filtrar por categoria</mat-label>
          <mat-select formControlName="categoria">
            <mat-option [value]="0">
              Todas
            </mat-option>
            <div *ngFor="let categoria of categorias">
              <mat-option [value]="categoria.id">
                {{categoria.nombre}}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
        <div class="gap"></div>
        <mat-form-field appearance="outline" class="filters__normal">
          <mat-label>Filtrar por estado</mat-label>
          <mat-select formControlName="pendientes">
            <mat-option *ngFor="let estado of pendientes" [value]="estado.key">
              {{estado.value}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <table *ngIf="metasFiltradas$ | async as dataSource" mat-table #table
       [dataSource]="dataSource" multiTemplateDataRows
       class="mat-elevation-z4">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 160px;">Código</th>
        <td mat-cell *matCellDef="let element;" style="width: 160px;">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="cambiarEstado($event, element)" [value]="element.id" [checked]="element.isSelected">
            {{element.codigo}}-{{element.id}}
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="categoria">
        <th mat-header-cell *matHeaderCellDef style="width: 180px;"><label style="text-align: left">Categoría<br>Subcategoría</label></th>
        <td mat-cell *matCellDef="let element;" style="width: 180px;">
          <span>
            <strong>{{element.categoria.agrupador}}</strong>
            <br>
            {{element.categoria.nombre}}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td *matCellDef="let element">
          <span class="short-description">
          {{(element.txtFR.length > 0 ? element.txtFR : element.txtEN.length > 0 ? element.txtEN : element.txtES) |
          HTMLEntitiesCleaner}}
        </span>
          </td>
      </ng-container>
      <ng-container matColumnDef="alumnos">
        <th mat-header-cell *matHeaderCellDef style="width: 180px;">Alumnos NA/P</th>
        <td mat-cell *matCellDef="let element" style="width: 180px;">
          <span *ngIf="element.alumnosPendientes ? element.alumnosPendientes.length > 0 : false" class="pendientes">{{element.alumnosPendientes.length}}</span>
          </td>
      </ng-container>
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
          <div class="example-element-detail"
              [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <div class="example-element-description">
              <app-meta-list-expanded [meta]="element" [expanded]="element === expandedElement"></app-meta-list-expanded>
            </div>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let element; columns: displayedColumns;"
          class="example-element-row"
          [class.example-expanded-row]="displayedColumns === element"
          (click)="expandedElement = displayedColumns === element ? null : element">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>
    <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[5, 10, 20, 50]" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>
</div>
<div class="cm-botones" *ngIf="!guardando">
  <button style="margin-right: 4px;" mat-button (click)="cancelar()">Cancelar</button>
  <button mat-raised-button color="primary" (click)="onSubmit()">Guardar</button>
</div>
<div class="cm-botones" *ngIf="guardando">
  <mat-progress-bar mode="query"></mat-progress-bar>
</div>
